import { defineComponent as _defineComponent } from 'vue'
import Student from "@/interfaces/student.interface";
import { AuthLog } from "@/interfaces/AuthLog.interface";
import { format, parseISO } from "date-fns";
import useHttpRequest from "@/composables/use-http-request";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'security-logs.component',
  props: {
    student: null
  },
  setup(__props: any) {

let scope: { row: AuthLog; $index: number };



const formattedDate = (date: string) =>
  format(parseISO(date), "dd MMM yyyy hh:mma");

const exportSecurityLogsToExcel = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    link: string;
  }>({
    method: "GET",
    url: "students/export-auth-logs",
    loadingProperty: null,
    showSuccessMessage: false,
    showFullScreenLoader: true,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "Security Logs exported successfully"
  ) {
    const link = document.createElement("a");
    link.href = request.link;
    link.click();
  }
};

return { __sfc: true,scope, formattedDate, exportSecurityLogsToExcel }
}

})